var _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmailGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_737_53170",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_737_53170",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAZ1JREFUWEftlr+SgjAQxlkyEUpLSktLyyt9BEvUJo9wj3KPkAak9BEoLS0tLSwsLfkzs7nZGXFyXFSE3ODNQAlhv99+2WwWnJ4f6FnfGQDezwEhhJ9l2QcAjG3Wh+u6Z875QUp50eP+cEAIEeR5LgDAtylexQKAC+c8kVKeb+90ofV6/amUspp5PRGCiKLo6xdAGIYT13WF/oNSar/ZbLZd3FgulwsAmOkxEFEmSXKkd7ctWK1WtGhRF+sCYRK/xt/Gcby/C4CIKWNsVm1HGwhdnGwHgD0izhsBOI6zHY1Gx7IsRRuIujjnXBZFMdEcfuwAAZBFQojxqxAmcTp6tS1uBkB2vQJxT5zitAZoCvFIvDPAM4hn4lYATBBU3YjoV53z2ulkvd1aAzBB1NqsUdwqQAWR5/lcKRUwxnxEPHietzNlXgF2KsIurXgA+D8O6Ndxm8vnUZ3QlFUUBd20U1pnvI7pQ68DyfV4BWVZhn81FSmlMs/zqFeYRzKt0UwRMbBx/KoYjLHL6XTapWma6XHfbyy3mXWTWIMDvTvwDSNfjDDppHiWAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailGrey);
export default __webpack_public_path__ + "static/media/email_grey.2127fde9f8fa6cba006c8e728134bfbe.svg";
export { ForwardRef as ReactComponent };